import Api from '~/api'
import { push } from 'react-router-redux'
import { Map, List, fromJS } from 'immutable'
import { resetForm, formSuccess, isLoading, formError } from '~/form/actions'

export function batchCreatePeople(people, project_id = false, list_id = false) {
  return (dispatch, getState) => {
    let { location = {} } = getState().routing || {}
    location.search = ''

    dispatch(batchCreatePeopleLoading(true))

    Api.post('/people/batch', { people, project_id, list_id })
      .then(({ data }) => {
        if (data.success) {
          dispatch(batchCreatePeopleSuccess(data.items, data.project_id, data.list_id))
          dispatch(push(location))
        }

        if (data.message) dispatch(batchCreatePeopleError(data.message))
      })
      .catch(err => dispatch(batchCreatePeopleError(err.message || 'Error when batch creating people')))
  }
}

export function batchCreatePeopleLoading(loading) {
  return {
    type: 'PEOPLE_BATCH_CREATE_LOADING',
    loading,
  }
}

export function batchCreatePeopleSuccess(people, project_id, list_id) {
  return {
    type: 'PEOPLE_BATCH_CREATE_SUCCESS',
    people,
    project_id,
    list_id,
  }
}

export function batchCreatePeopleError(message) {
  return {
    type: 'PEOPLE_BATCH_CREATE_ERROR',
    message,
  }
}

/* Edit person */

export function editPerson(formId, id, values) {
  return (dispatch, getState) => {
    let { location = {} } = getState().routing || {}
    location.search = ''

    dispatch(isLoading(formId, true))
    Api.patch(`/people/${id}`, { values })
      .then(({ data }) => {
        if (data.success) {
          console.log(data.list_id)
          dispatch(
            editPersonSuccess(
              data.item,
              data.project_id,
              data.update_new_interview || false,
              data.update_old_interview || false,
              data.list_id
            )
          )
          dispatch(resetForm(formId))
          dispatch(push(location))
        }

        if (data.message) dispatch(formError({ messages: [data.message] }))
      })
      .catch(err => dispatch(formError({ messages: [err.message || 'Error when batch creating people'] })))
      .finally(() => dispatch(isLoading(formId, false)))
  }
}

export function editPersonLoading(loading) {
  return {
    type: 'PEOPLE_EDIT_LOADING',
    loading,
  }
}

export function editPersonSuccess(item, project_id, update_new_interview, update_old_interview, list_id) {
  return {
    type: 'PEOPLE_EDIT_SUCCESS',
    item,
    project_id,
    update_new_interview,
    update_old_interview,
    list_id,
  }
}

export function editPersonError(message) {
  return {
    type: 'PEOPLE_EDIT_ERROR',
    message,
  }
}
